{
    "ai_modal_title_1": "Pagbutihin ang iyong teksto gamit ang AI",
    "ai_modal_title_2": "Bumuo ng bagong text gamit ang AI",
    "ai_description": "Gumamit ng mga tool sa pagbuo ng nilalaman ng AI upang mapabuti ang iyong mga teksto.",
    "ai_learn_more": "Matuto pa",
    "ai_copy_text": "Kopyahin ang text",
    "ai_describe_your_text": "Ilarawan kung tungkol saan dapat ang iyong teksto",
    "ai_describe_your_text_example": "Halimbawa: isang maikling paglalarawan para sa isang online na tindahan na nagbebenta ng handmade na sabon",
    "ai_new_request": "Gumawa ng bagong kahilingan",
    "ai_create_text": "Bumuo ng teksto",
    "ai_apply_text": "Mag-apply ng text",
    "ai_try_one_more": "Subukan muli",
    "ai_correct_errors": "Itama ang mga pagkakamali",
    "ai_make_longer": "Palawigin",
    "ai_make_shorter": "paikliin",
    "ai_simplify": "Pasimplehin",
    "ai_business_tone": "Pormal",
    "ai_ceremonial_tone": "Maligaya",
    "ai_fun_tone": "Masaya",
    "ai_friendly_tone": "Friendly",
    "ai_change_tone": "Baguhin ang tono ng boses",
    "ai_improve_text": "Pagbutihin ang teksto",
    "ai_words_number": "Bilang ng mga Salita:",
    "ai_translate": "Isalin",
    "ai_translate_to_ru": "Isalin sa russian",
    "ai_translate_to_en": "Isalin sa ingles",
    "ai_add_creativity": "Magdagdag ng pagkamalikhain",
    "ai_text_too_large": "Masyadong mahaba ang iyong text para magamit ang AI. Gawin itong mas maikli o bumuo ng isang bagong teksto sa kinakailangang paksa sa tulong ng AI.",
    "ai_translate_to_ua": "Isalin sa ukrainian",
    "ai_translate_to_es": "Isalin sa espanyol",
    "ai_translate_to_pt": "Isalin sa portuguese",
    "ai_translate_to_tr": "Isalin sa turkish",
    "ai_translate_to_fr": "Isalin sa pranses",
    "ai_translate_to_de": "Isalin sa german",
    "ai_translate_to_it": "Isalin sa italian",
    "ai_translate_to_pl": "Isalin sa polish",
    "ai_free_request_error": "Tapos na ang mga libreng kahilingan",
    "ai_free_request_number": "Numero ng kahilingan: {{ FREE_KEY }} / {{ FREE_KEY_LIMIT }}",
    "ai_request_limit_info": "Maaari kang gumamit ng hanggang 200 libreng AI tool request. Upang lumikha ng higit pang mga request, i-activate ang iyong mga API key sa provider ng AI sa mga setting ng iyong account.",
    "cancel": "Kanselahin",
    "gpt_error_quota": "Naabot mo na ang iyong limitasyon sa kahilingan sa API. Upang magpatuloy sa paggamit ng mga tool ng AI, suriin ang iyong kasalukuyang limitasyon o magdagdag ng mga pondo sa balanse ng iyong kredito sa mga setting ng OpenAI account.",
    "ai_generated_disclaimer": "Ikaw ang may pananagutan sa nabuong teksto. Suriin ito bago i-publish."
}
